// extracted by mini-css-extract-plugin
export default {"emptyChartWrapper":"EmptyChart_emptyChartWrapper__x06Yg","emptyChartPanel":"EmptyChart_emptyChartPanel__vC-ec","emptyChartContent":"EmptyChart_emptyChartContent__QjeHW"};